import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Validate from 'app/validation/validation';

import './expert_page.scss';


import { getMediaPath } from "../../app/functions";

//components
import AnimatedInput from "../../components/forms/animated_input";
import AnimatedTextArea from "../../components/forms/animated_textarea";
import Select from "../../components/forms/select";
import * as routes from "../../constants/routes";


//assets
import logo from 'assets/logos/logo.svg';
import ImageHeader from "../../components/image-header";

import { useGetExpertsPageQuery, useSendExpertQuestionMutation } from '../../redux/api/relations.api';

const normalizeExpertId = (id) => (id && id !== '-1' ? String(id) : -1);

function ExpertPage() {
    const device = useSelector(store => store.state.deviceState);
    const text = useSelector(store => store.config.Translations);
    const requesting = useSelector(store => store.state.requesting);
    const location = useLocation();
    const history = useHistory();

    const idFromUrl = new URLSearchParams(location.search).get('id');
    const [expertId, setExpertId] = useState(() => normalizeExpertId(idFromUrl) || -1);

    const {data: getExpertsPageData} = useGetExpertsPageQuery();
    const [expertsPage, setExpertsPage] = useState(getExpertsPageData); 

    const [sendExpertQuestion, {isLoading: isSendingExpertLead}] = useSendExpertQuestionMutation();

    const [showThanks, setShowThanks] = useState(false);

    const [openOnForm, setOpenOnForm] = useState(false);
    const [firstTry, setFirstTry] = useState(true);
    const [form, setForm] = useState({
        full_name: { val: '', valid: false, rules: ['not_empty'], errMsg: '' },
        id: { val: '', valid: false, rules: ['id'], errMsg: '' },
        email: { val: '', valid: false, rules: ['not_empty', 'email'], errMsg: '' },
        phone: { val: '', valid: false, rules: ['not_empty', 'phone'], errMsg: '' },
        message: { val: '', valid: false, rules: ['not_empty'], errMsg: '' }
    });
    const [subject, setSubject] = useState({ errMsg: '', selected: -1, valid: false });

    const ref = useRef();


    useEffect(() => {
        if (getExpertsPageData) {
            setExpertsPage(getExpertsPageData);
        }
    }, [getExpertsPageData]);

    useEffect(() => {
        const idFromUrl = new URLSearchParams(location.search).get('id');
        const normalizedId = normalizeExpertId(idFromUrl) || -1;
        setExpertId(normalizedId);
    }, [location.search]);

    useEffect(() => {
        if (expertId === -1 || !expertsPage) return;

        const expertExists = expertsPage.experts?.some(
            (item) => String(item.id) === String(expertId)
        );
        if (expertExists) {
            setOpenOnForm(true);
        } else {
            setExpertId(-1);
            history.replace(routes.experts);
        }
    }, [expertId, expertsPage]);

    useEffect(() => {
        if (openOnForm && expertsPage) {
            scrollToExperts();
            setOpenOnForm(false);
        }
    }, [openOnForm, expertsPage]);

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        let validate = Validate(value, form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        setForm(prevForm => ({
            ...prevForm,
            [name]: { ...prevForm[name], val: value, valid: is_valid, errMsg: msg }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let form_valid = true;
        let new_state = { ...form };

        for (let field in form) {
            let validate = Validate(form[field].val, form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if (is_valid === false) {
                form_valid = false;
            }
        }

        const subjectSelected = subject.selected !== -1;

        if (!subjectSelected) {
            setSubject(prevSubject => ({ ...prevSubject, errMsg: 'אנא בחרו נושא' }));
        }

        setForm(new_state);
        setFirstTry(false);

        if (form_valid && subjectSelected) {
            let payload = {};
            for (let key in form) {
                payload[key] = form[key].val;
            }
            payload['subjectId'] = subject.selected;
            payload['expertId'] = expertId;
            handleSendExpertQuestion(payload);
        }
    };

    const handleSendExpertQuestion = async (payload) => {
        try {
            const response = await sendExpertQuestion(payload);
            if (response.data) {
                setShowThanks(true);
            }
        } catch (error) {
            console.error('Error sending expert question:', error);
        }
    };
    

    const handleExpertOnClick = (id) => {
        setExpertId(String(id));
        history.push(`${routes.experts}?id=${id}`);
        scrollToExperts();
    };

    const scrollToExperts = () => {
        const scroll = () => {
            if (ref.current) {
                window.scrollTo(0, ref.current.offsetTop - 100);
            }
        };
        requestAnimationFrame(() => requestAnimationFrame(scroll));
    };

    const getExperts = () => {
        const experts = expertsPage.experts;
        let res = [];

        experts.forEach((item, index) => {
            res.push(
                <div key={index} className={'expert-wrapper ' + ((expertId === -1) ? 'normal' : (String(item.id) === String(expertId) ? 'selected' : ''))}
                     onClick={() => handleExpertOnClick(item.id)}>
                    <div className='image-wrap'>
                        <img src={getMediaPath(item.image_path)} alt='/' />
                    </div>
                    <span className='name'>{item.name}</span>
                    <span className='content'>{item.content}</span>
                </div>
            );
        });

        return res;
    };

    const isMobile = device !== 'mobile';
    let bannerPath = null;
    if (expertsPage) {
        bannerPath = getMediaPath(isMobile ? expertsPage.image_path : expertsPage.mobile_image_path);
    }

    const showErrorName = !firstTry && !form.full_name.valid;
    const showErrorId = !firstTry && !form.id.valid;
    const showErrorEmail = !firstTry && !form.email.valid;
    const showErrorPhone = !firstTry && !form.phone.valid;
    const showErrorMassage = !firstTry && !form.message.valid;
    const showErrorSubject = !firstTry && !subject.valid;

    let showForm = false;
    let subjects = [];
    let expertData = {};

    if (expertsPage && expertId !== -1) {
        const selected_expert = expertsPage.experts.filter(item => {
            return String(item.id) === String(expertId);
        });

        if (selected_expert[0]) {
            expertData = selected_expert[0];
            showForm = true;

            selected_expert[0].subjects.forEach(item => {
                subjects.push({ id: item.id, text: item.title });
            });
        }
    }


    return (
        <section className='experts-page'>
            {expertsPage &&
                <>
                    <ImageHeader
                        title={expertsPage?.title}
                        subtitle={expertsPage?.subtitle}
                        image={bannerPath}
                    />

                    <div className='experts-container'>
                        {getExperts()}
                    </div>

                    <div ref={ref}>
                        {showForm && (
                            <form id='ask-the-expert-form' onSubmit={handleSubmit}>
                                <h4 className="form-title">
                                    {text['experts_page_form_title'] + ' '}
                                    {expertData['name']}, {expertData['content']}
                                </h4>

                                <div className={'select_input ' + (showErrorSubject ? 'error' : '')}>
                                    <Select placeholder={text['experts_subject_placeholder']}
                                            options={subjects}
                                            deviceState={'desktop'}
                                            onChange={(item) => setSubject(prevSubject => ({ ...prevSubject, selected: item, valid: true }))}
                                    />
                                    <span className='error_msg'>{subject.errMsg}</span>
                                </div>

                                <AnimatedTextArea className={'field'}
                                                  value={form.message.val}
                                                  name={'message'}
                                                  placeholder={text['expert_message']}
                                                  onChange={handleInputChange}
                                                  showError={showErrorMassage}
                                                  errorMessage={form.message.errMsg}
                                />
                                <div className='first-row'>
                                    <AnimatedInput className={'field name'}
                                                   value={form.full_name.val}
                                                   name={'full_name'}
                                                   placeholder={text['expert_full_name']}
                                                   onChange={handleInputChange}
                                                   showError={showErrorName}
                                                   errorMessage={form.full_name.errMsg}
                                    />
                                    <AnimatedInput className={'field'}
                                                   value={form.id.val}
                                                   name={'id'}
                                                   placeholder={text['expert_id']}
                                                   onChange={handleInputChange}
                                                   showError={showErrorId}
                                                   errorMessage={form.id.errMsg}
                                    />
                                    <AnimatedInput className={'field email'}
                                                   value={form.email.val}
                                                   name={'email'}
                                                   placeholder={text['expert_email']}
                                                   onChange={handleInputChange}
                                                   showError={showErrorEmail}
                                                   errorMessage={form.email.errMsg}
                                    />
                                    <AnimatedInput className={'field phone'}
                                                   value={form.phone.val}
                                                   name={'phone'}
                                                   placeholder={text['expert_phone']}
                                                   onChange={handleInputChange}
                                                   showError={showErrorPhone}
                                                   errorMessage={form.phone.errMsg}
                                    />
                                </div>
                                <input type='submit' name="submit" className={'submit-btn ' + (requesting ? 'disabled' : '')} value={expertsPage.btn_text} />
                            </form>
                        )}
                    </div>

                    {showThanks &&
                        <div className='success-layout'>
                            <img className='logo' src={getMediaPath(logo)} alt='/' />
                            <h1 className='message'>{text['experts_thanks_msg']}</h1>
                            <NavLink to={routes.home} className='back-link'>{text.web_return_to_home}</NavLink>
                        </div>
                    }
                </>
            }
        </section>
    );
}

export default ExpertPage;
